<template>
    <div class="base-table" id="base-table">
        <el-table ref="singleTable" @current-change="handleCurrentChange" @row-click="rowClick" :fit="true" :data="tableInit.body" @sort-change="sortChange" highlight-current-row style="width: 100%" :height="tableHeight" border>
            <template v-for="(val ,index) in tableInit.thead" >
                <!-- 有排序表单 -->
                <template v-if="val.sortable">
                    <el-table-column sortable="custom" :prop="val.code" :label="val.label" :width="val.width?val.width:''" :key="val.code" :id="val.code+ index">
                        <template scope="scope">
                            <span v-if="val.link"><a v-if="val.link" href="javascript:void(0)" @click="queryItem(scope.row)">{{scope.row[val.code]}}</a></span>
                            <span v-else-if="val.dictionary!=null &&val.dictionary=='date'">{{parse_date(scope.row[val.code])}}</span>
                            <span v-else-if="val.dictionary!=null &&val.dictionary=='qualLevel'">{{parse_qualLevel(scope.row[val.code],scope.row['qualGrade'])}}</span>
                            <span v-else-if="val.dictionary!=null">{{parse_str(scope.row[val.code] ,val.dictionary ,index)}}</span>
                            <span v-else>{{scope.row[val.code]}}</span>
                        </template>
                    </el-table-column>
                </template>

                <template v-else>
                    <!-- 无排序表单 -->
                    <el-table-column :label="val.label" :prop="val.code" :width="val.width?val.width:''" :key="val.code">
                        <template scope="scope" >
                            <a v-if="val.link" href="javascript:void(0)" @click="queryItem(scope.row)">{{scope.row[val.code]}}</a>
                            <span v-else-if="val.dictionary!=null &&val.dictionary=='date'">{{parse_date(scope.row[val.code])}}</span>
                            <span v-else-if="val.dictionary!=null &&val.dictionary=='qualLevel'">{{parse_qualLevel(scope.row[val.code],scope.row['qualGrade'])}}</span>
                            <span v-else-if="val.dictionary!=null">{{parse_str(scope.row[val.code] ,val.dictionary)}}</span>
                            <span v-else>{{scope.row[val.code]}}</span>
                        </template>
                    </el-table-column>
                </template>
</template>
        </el-table>
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: ["tableHeight", "tableInit", "dirs"],
  mounted(){
	//   console.log(this.tableInit)
  },
  data() {
    return {
      currentRow: null,
      show1: false,
      radio: ""
    };
  },
  methods: {
    // radioClick(index) {
    //     console.log(index)
    // },
    rowClick(row, event, column) {
      // console.log(row)
      // for (let i in event.path) {
      //     if (event.path[i].localName.toUpperCase() == "TR") {
      //         index = event.path[i].rowIndex;
      //         break;
      //     }
      // }
      // console.log(index)
      // this.radio = index;
      // this.$emit("passcurrentRow", [{ currentRow: row, tableCode: this.tableInit.table_code }])
    },
    // setCurrent(row) {
    //     this.$refs.singleTable.setCurrentRow(row);
    // },
    handleCurrentChange(val) {
      this.currentRow = val;
    //   console.log(val);
      this.$emit("passcurrentRow", [
        { currentRow: val, tableCode: this.tableInit.table_code }
      ]);
    },
    queryItem(row) {
      this.$emit("queryItem", row);
    },
    sortChange(val) {
      this.$emit("sortChange", val);
    },
    parse_str(val, dirName, index) {
		// if(dirName == "opstatemc"){
		// 	console.log(val)
		// }
      let name = "";
      let dirs = this.dirs[dirName];
      if (!dirs) return;
      for (let i = 0, j = dirs.length; i < j; i++) {
        if (dirs[i].code == val) {
          name = dirs[i].name;
          // break;
        }
      }
      if (name == "全部") return "";
      return name;
    },
    parse_qualLevel(grade,level) {
      let zizhi = "";
      let dengji = "";
      let dirs = this.dirs.qualLevel['grade'];
      for (let i = 0, j = dirs.length; i < j; i++) {
        if (dirs[i].code == grade) {
          zizhi = dirs[i].name;
        }
      }
      let dirs2 = this.dirs.qualLevel['level'];
      for (let i = 0, j = dirs2.length; i < j; i++) {
        if (dirs2[i].code == level) {
          dengji = dirs2[i].name;
        }
      }
      return zizhi+dengji;
    },
    parse_date(val) {
      if (!val) return "";
      let t_date = val.replace(new RegExp(/-/gm), "/"); //将所有的'-'转为'/'即可
      let d = new Date(t_date);
      if (isNaN(d.getDate())) return "";
      let year = d.getFullYear();
      let month = d.getMonth() + 1;
      let date = d.getDate();
      return (
        year +
        "-" +
        (month >= 10 ? month : "0" + month) +
        "-" +
        (date >= 10 ? date : "0" + date)
      );
    }
  }
};
</script>
<style>
* {
  font-size: 12px;
}

.base-table {
  width: 100%;
  padding: 0 5px 5px;
}

.base-table .el-radio__label {
  display: none;
}
</style>



// WEBPACK FOOTER //
// base_table.vue?3a9d9918